import Grid from '@blocks/Grid'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import React, { useMemo } from 'react'
import SalonParticipationByType from './components/ParticipationByType'
import SalonSectionContext from './context'

export default function SalonSection({ section }: Props) {
    const { salon, gallery } = useSalonContext()

    if (!section.participations.length && salon.state.type !== "current") 
        return null

    const photos = useMemo(() => getPhotos(salon, gallery, section), [section, gallery])
    const row = getRow(section)

    return (
        <SalonSectionContext.Provider value={{ section, photos }}>
            <Grid gap="20px">
                <Grid gap="5px">
                    <h2 className="h3">{section.name}</h2>
                    {section.limit ? <small>Acceptance score: {section.limit} points.</small> : null}
                </Grid>
                <Grid columns="4">
                    {row.map((participation, idx) => {
                        const position = participation ? `${participation.id}` : `${section.id}:${idx}`
                        return <SalonParticipationByType key={position} position={position} participation={participation} />
                    })}
                </Grid>
            </Grid>
        </SalonSectionContext.Provider>
    )
}

interface Props {
    section: Customer.Resources.PastSection | Customer.Resources.Section
}

/**
 * Gets photos for a section.
 */
function getPhotos(
    salon: Customer.Models.Salon.Stateful, 
    gallery: Customer.Models.Gallery, 
    section: Customer.Resources.PastSection | Customer.Resources.Section
): Interfaces.Photo[] | undefined {
    if (salon.state.type !== "current")
        return
        
    const existing = section.participations.map((item: Customer.Resources.Participation) => item.photo_id)
    return gallery.state?.filter(item => !existing.includes(item.id))
}

/**
 * Gets a row with four elements.
 */
function getRow(section: Customer.Resources.PastSection | Customer.Resources.Section): (Customer.Resources.Participation | Customer.Resources.PastParticipation | null)[] {
    const empty = [null, null, null, null]
    return [...section.participations, ...empty].slice(0, 4)
}